import { render, staticRenderFns } from "./CloverResponseGr8.vue?vue&type=template&id=52e90fb0&"
import script from "./CloverResponseGr8.vue?vue&type=script&lang=js&"
export * from "./CloverResponseGr8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports